module.exports = __webpack_public_path__ + "static/img/notice-character.4011f4c.png";